class EfdAlertasList {
    maybeFormatCurrency(value) {
        if (value) {
            var valor = parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            return '<span> ' + valor + ' <span>';
        } else {
            return '<span class="empty">Vazio</span>';
        }
    }

    maybeFormatPercent(valueField, valueToCompare) {
        if (valueField) {
            var valor = parseFloat(valueField).toLocaleString('pt-BR', { minimumFractionDigits: 4 })
            return '<span>' + valor + ' % </span>'
        } else {
            return (valueField == valueToCompare) ? '<span class="empty"> - </span>' : '<span class="empty"> Vazio </span>'
        }
    }
}

angular.module('eficienciaFiscalModule')
    .component('efdAlertasList', {
        controller: EfdAlertasList,
        bindings: {
            efd: '<',
            alertas: '<'
        },
        template: `
            <div ng-repeat="alerta in $ctrl.alertas" ng-switch="alerta.tipo">
                <div ng-switch-when="NFE_RECEBIDA_AUSENTE">
                    <efd-alerta-nfe 
                        chave="alerta.nfeRecebidaAusente.nfe.chave"
                        numero="alerta.nfeRecebidaAusente.nfe.numero"
                        emissao="alerta.nfeRecebidaAusente.nfe.emissao"
                        emissao-propria="false"
                        participante="alerta.nfeRecebidaAusente.nfe.emitente">
                    </efd-alerta-nfe>
                </div>

                <div ng-switch-when="NFE_EMITIDA_AUSENTE">
                    <efd-alerta-nfe 
                        chave="alerta.nfeEmitidaAusente.nfe.chave"
                        numero="alerta.nfeEmitidaAusente.nfe.numero"
                        emissao="alerta.nfeEmitidaAusente.nfe.emissao"
                        emissao-propria="true"
                        participante="alerta.nfeEmitidaAusente.nfe.destinatario">
                    </efd-alerta-nfe>
                </div>

                <div ng-switch-when="NFE_RECEBIDA_AUSENTE_NO_EF">
                    <efd-alerta-nfe 
                        chave="alerta.nfeRecebidaAusenteNoEf.notaFiscal.chave"
                        numero="alerta.nfeRecebidaAusenteNoEf.notaFiscal.numero"
                        emissao="alerta.nfeRecebidaAusenteNoEf.notaFiscal.emissao"
                        emissao-propria="false"
                        participante="alerta.nfeRecebidaAusenteNoEf.notaFiscal.participante">
                    </efd-alerta-nfe>
                </div>

                <div ng-switch-when="NFE_EMITIDA_AUSENTE_NO_EF">
                    <efd-alerta-nfe 
                        chave="alerta.nfeEmitidaAusenteNoEf.notaFiscal.chave"
                        numero="alerta.nfeEmitidaAusenteNoEf.notaFiscal.numero"
                        emissao="alerta.nfeEmitidaAusenteNoEf.notaFiscal.emissao"
                        emissao-propria="true"
                        participante="alerta.nfeEmitidaAusenteNoEf.notaFiscal.participante">
                    </efd-alerta-nfe>
                </div>

                <div ng-switch-when="NFE_PARTICIPANTE_DIVERGENTE">
                    <efd-alerta-nfe 
                        chave="alerta.nfeParticipanteDivergente.nfe.chave"
                        numero="alerta.nfeParticipanteDivergente.nfe.numero"
                        emissao="alerta.nfeParticipanteDivergente.nfe.emissao"
                        emissao-propria="alerta.nfeParticipanteDivergente.nfe.emissaoPropria"
                        participante="alerta.nfeParticipanteDivergente.participanteNfe">
                        <hr>
                        <div class="labeled-info">
                            <b>PARTICIPANTE NO EFD</b>
                            <br/>
                            <span>
                                {{alerta.nfeParticipanteDivergente.participanteEfd.nome}} 
                                <span>{{alerta.nfeParticipanteDivergente.participanteEfd ? ' - ' : 'Não informado' }}</span>
                                <small class="text-muted">
                                    {{alerta.nfeParticipanteDivergente.participanteEfd.cpfCnpj | cpfCnpj}}
                                </small>
                            </span>
                        </div>
                    </efd-alerta-nfe>
                </div>

                <div ng-switch-when="NFE_DUPLICADA">
                    <efd-alerta-nfe 
                        chave="alerta.nfeDuplicada.notaFiscalOriginal.chave"
                        numero="alerta.nfeDuplicada.notaFiscalOriginal.numero"
                        emissao="alerta.nfeDuplicada.notaFiscalOriginal.emissao"
                        emissao-propria="alerta.nfeDuplicada.notaFiscalOriginal.emissaoPropria"
                        participante="alerta.nfeDuplicada.notaFiscalOriginal.participante">
                        <hr>
                        <div class="labeled-info">
                            <b>ARQUIVO</b>
                            <br/>
                            <span>
                                EFD {{alerta.nfeDuplicada.notaFiscalOriginal.efd.tipo === 'ICMS' ? 'ICMS' : 'PIS/COFINS'}} 
                                do mês {{alerta.nfeDuplicada.notaFiscalOriginal.efd.dataReferencia | date: 'MMM/yyyy'}}
                            </span>
                        </div>
                    </efd-alerta-nfe>
                </div>

                <div ng-switch-when="NFE_CANCELADA">
                    <efd-alerta-nfe 
                        ng-show="alerta.nfeCancelada.notaFiscal"
                        chave="alerta.nfeCancelada.notaFiscal.chave"
                        numero="alerta.nfeCancelada.notaFiscal.numero"
                        emissao="alerta.nfeCancelada.notaFiscal.emissao"
                        emissao-propria="alerta.nfeCancelada.notaFiscal.emissaoPropria"
                        participante="alerta.nfeCancelada.notaFiscal.participante">
                        <hr>
                        <div class="labeled-info">
                            <b>Descrição</b>
                            <br/>
                            <span>
                                Lançamento de cancelamento não identificado no Eficiência Fiscal referente ao 
                                EFD {{alerta.nfeCancelada.notaFiscal.efd.tipo === 'ICMS' ? 'ICMS' : 'PIS/COFINS'}}.
                            </span>
                        </div>
                    </efd-alerta-nfe>
                    <efd-alerta-nfe 
                        ng-hide="alerta.nfeCancelada.notaFiscal"
                        chave="alerta.nfeCancelada.nfe.chave"
                        numero="alerta.nfeCancelada.nfe.numero"
                        emissao="alerta.nfeCancelada.nfe.emissao"
                        emissao-propria="alerta.nfeCancelada.nfe.emissaoPropria"
                        participante="alerta.nfeCancelada.nfe.participante">
                        <hr>
                        <div class="labeled-info">
                            <b>Descrição</b>
                            <br/>
                            <span>
                                Lançamento de cancelamento não identificado no EFD.
                            </span>
                        </div>
                    </efd-alerta-nfe>
                </div>

                <div ng-switch-when="CTE_FOB_AUSENTE">
                    <efd-alerta-nfe 
                        chave="alerta.cteFobAusente.cte.chave"
                        numero="alerta.cteFobAusente.cte.numero"
                        emissao="alerta.cteFobAusente.cte.emissao"
                        emissao-propria="false"
                        participante="alerta.cteFobAusente.cte.emitente">
                    </efd-alerta-nfe>
                </div>

                <div ng-switch-when="NFE_ITEM_VALOR_ICMS_DIVERGENTE">
                    <efd-alerta-nfe
                        chave="alerta.nfeItemValorIcmsDivergente.nfe.chave"
                        numero="alerta.nfeItemValorIcmsDivergente.nfe.numero"
                        emissao="alerta.nfeItemValorIcmsDivergente.nfe.emissao"
                        emissao-propria="false"
                        participante="alerta.nfeItemValorIcmsDivergente.nfe.emitente">
                        <hr>
                        <div>
                            <span style="font-size: 17px;">Crédito ICMS no EFD diferente do destacado na NF-e</span>
                            <i 
                                class="fa fa-info-circle" 
                                tooltip="Esta divergência não indica necessariamente um erro, contudo, 
                                vale observar que ela pode ser ocasionada por motivos como: item com finalidade uso e consumo,
                                ativo imobilizado, ou ainda, produtos sujeitos a ST na UF destino da operação">
                            </i>
                        </div>
                        <table class="alerta-item-divergente" style="width: 100%;">
                            <thead>
                                <tr>
                                    <th rowspan="2" style="width: 15%;">Código</th>
                                    <th rowspan="2" style="width: 65%;">Descrição</th>
                                    <th colspan="2" class="text-center" style="width: 12%;">Valor ICMS</th>
                                </tr>
                                <tr class="table-item-divergente">
                                    <th>NF-e</th>
                                    <th>EFD</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr ng-repeat="item in alerta.nfeItemValorIcmsDivergente.itensIcmsDivergentes">
                                    <td style="text-align: left;">{{ item.divergencia.codigo }}</td>
                                    <td style="text-align: left;">{{ item.divergencia.descricao }}</td>
                                    <td class="text-right" ng-bind-html="$ctrl.maybeFormatCurrency(item.divergencia.valorIcmsNfe)"></td>
                                    <td class="text-right" ng-bind-html="$ctrl.maybeFormatCurrency(item.divergencia.valorIcmsEfd)"></td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td></td>
                                    <td class="text-right text-bold"> TOTAL: </td>
                                    <td class="text-bold text-right" ng-bind-html="$ctrl.maybeFormatCurrency(alerta.nfeItemValorIcmsDivergente.valorTotalIcmsNfe)"></td>
                                    <td class="text-bold text-right" ng-bind-html="$ctrl.maybeFormatCurrency(alerta.nfeItemValorIcmsDivergente.valorTotalIcmsEfd)"></td>
                                </tr>
                            <tfoot>   
                        </table>
                    </efd-alerta-nfe>
                </div>

                <div ng-switch-when="NFE_ITEM_DADOS_DIVERGENTES">
                    <efd-alerta-nfe
                        chave="alerta.nfeItemDadosDivergentes.nfe.chave"
                        numero="alerta.nfeItemDadosDivergentes.nfe.numero"
                        emissao="alerta.nfeItemDadosDivergentes.nfe.emissao"
                        emissao-propria="false"
                        participante="alerta.nfeItemDadosDivergentes.nfe.emitente">
                        <hr>
                        <h5>Dados de alíquotas divergentes</h5>
                        <table class="alerta-item-divergente" style="width: 100%;" ng-if="$ctrl.efd.tipo == 'ICMS'">
                            <thead>
                                <tr>
                                    <th rowspan="2" style="width: 15%;">Código</th>
                                    <th rowspan="2">Descrição</th>
                                    <th colspan="2" class="text-center" style="width: 20%;">Alíquota ICMS</th>
                                </tr>
                                <tr class="table-item-divergente">
                                    <th>NF-e </th>
                                    <th>EFD</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr ng-repeat="item in alerta.nfeItemDadosDivergentes.itensDivergentes.itensDivergentesIcms">
                                    <td style="text-align: left;">{{ item.divergencia.codigo }}</td>
                                    <td style="text-align: left;">{{ item.divergencia.descricao }}</td>
                                    <td ng-bind-html="$ctrl.maybeFormatPercent(item.divergencia.aliquotaIcms.valorItemNfe, item.divergencia.aliquotaIcms.valorItemEfd)"></td>
                                    <td ng-bind-html="$ctrl.maybeFormatPercent(item.divergencia.aliquotaIcms.valorItemEfd, item.divergencia.aliquotaIcms.valorItemNfe)"></td>
                                </tr>
                            </tbody>   
                        </table>
                        <table class="alerta-item-divergente" style="width: 100%;" ng-if="$ctrl.efd.tipo == 'PIS_COFINS'">
                            <thead>
                                <tr>
                                    <th rowspan="2" style="width: 15%;">Código</th>
                                    <th rowspan="2">Descrição</th>
                                    <th colspan="2" class="text-center" style="width: 20%;">Alíquota PIS</th>
                                    <th colspan="2" class="text-center" style="width: 20%;">Alíquota COFINS</th>
                                </tr>
                                <tr class="table-item-divergente">
                                    <th>NF-e</th>
                                    <th>EFD</th>
                                    <th>NF-e</th>
                                    <th>EFD</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr ng-repeat="item in alerta.nfeItemDadosDivergentes.itensDivergentes.itensDivergentesPisCofins">
                                    <td style="text-align: left;">{{ item.divergencia.codigo }}</td>
                                    <td style="text-align: left;">{{ item.divergencia.descricao }}</td>
                                    <td ng-bind-html="$ctrl.maybeFormatPercent(item.divergencia.aliquotaPis.valorItemNfe, item.divergencia.aliquotaPis.valorItemEfd)"></td>
                                    <td ng-bind-html="$ctrl.maybeFormatPercent(item.divergencia.aliquotaPis.valorItemEfd, item.divergencia.aliquotaPis.valorItemNfe)"></td>
                                    <td ng-bind-html="$ctrl.maybeFormatPercent(item.divergencia.aliquotaCofins.valorItemNfe, item.divergencia.aliquotaCofins.valorItemEfd)"></td>
                                    <td ng-bind-html="$ctrl.maybeFormatPercent(item.divergencia.aliquotaCofins.valorItemEfd, item.divergencia.aliquotaCofins.valorItemNfe)"></td>
                                </tr>
                            </tbody>   
                        </table>
                    </efd-alerta-nfe>
                </div>

                <div ng-switch-when="NFE_DADOS_DIVERGENTES">
                    <efd-alerta-nfe 
                        chave="alerta.nfeDadosDivergentes.nfe.chave"
                        numero="alerta.nfeDadosDivergentes.nfe.numero"
                        emissao="alerta.nfeDadosDivergentes.nfe.emissao"
                        emissao-propria="false"
                        participante="alerta.nfeDadosDivergentes.nfe.emitente">
                        <hr>
                        <h5>Dados divergentes</h5>

                        <table class="alerta-dados-divergentes" style="width: 40%;">
                            <thead>
                                <th style="width: 25%;"></th>
                                <th class="text-right" style="width: 15%;">NF-e</th>
                                <th class="text-right" style="width: 15%;">EFD</th>
                            </thead>
                            <tbody>
                                <tr ng-if="alerta.nfeDadosDivergentes.valorNfe || alerta.nfeDadosDivergentes.valorEfd">
                                    <td class="titulo-identificador">VALOR TOTAL DO DOCUMENTO</td>
                                    <td class="text-right" ng-bind-html="$ctrl.maybeFormatCurrency(alerta.nfeDadosDivergentes.valorNfe)"></td>
                                    <td class="text-right" ng-bind-html="$ctrl.maybeFormatCurrency(alerta.nfeDadosDivergentes.valorEfd)"></td>
                                </tr>
                                <tr ng-if="alerta.nfeDadosDivergentes.valorIcmsNfe && alerta.nfeDadosDivergentes.valorIcmsEfd">
                                    <td class="titulo-identificador">VALOR TOTAL DO ICMS</td>
                                    <td class="text-right" ng-bind-html="$ctrl.maybeFormatCurrency(alerta.nfeDadosDivergentes.valorIcmsNfe)"></td>
                                    <td class="text-right" ng-bind-html="$ctrl.maybeFormatCurrency(alerta.nfeDadosDivergentes.valorIcmsEfd)"></td>
                                </tr>
                            </tbody>
                        </table>
                    </efd-alerta-nfe>
                </div>

                <div ng-switch-when="NFE_CFOP_CST_INCORRETO">
                    <efd-alerta-nfe 
                        chave="alerta.nfeCfopCstIncorreto.nfe.chave"
                        numero="alerta.nfeCfopCstIncorreto.nfe.numero"
                        emissao="alerta.nfeCfopCstIncorreto.nfe.emissao"
                        emissao-propria="false"
                        participante="alerta.nfeCfopCstIncorreto.nfe.emitente">
                        <hr>
                        <h5>Itens com inconsistência</h5>

                        <table>
                            <thead>
                                <tr>
                                    <th rowspan="2">Código item</th>
                                    <th rowspan="2">CFOP de entrada</th>
                                    <th rowspan="2">CFOP informado na EFD</th>
                                    <th rowspan="2">CST/CSOSN informado na EFD</th>
                                    <th colspan="2" class="text-center">Sugestões</th>
                                </tr>
                                <tr>
                                    <th>Possível CFOP</th>
                                    <th>Possíveis CSTs/CSOSNs</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr ng-repeat-start="itemSugestoes in alerta.nfeCfopCstIncorreto.sugestoes">
                                    <td rowspan="2">{{ itemSugestoes.item.codigo }}</td>
                                    <td rowspan="2">{{ itemSugestoes.item.cfopEntrada }}</td>
                                    <td rowspan="2">{{ itemSugestoes.item.cfopSaida }}</td>
                                    <td rowspan="2">{{ itemSugestoes.item.cstSaida }}</td>
                                    <td>{{ itemSugestoes.sugestoes[0].cfop }}</td>
                                    <td>{{ (itemSugestoes.sugestoes[0].csosns || itemSugestoes.sugestoes[0].csts) | array }}</td>
                                </tr>
                                <tr ng-repeat-end ng-repeat="sugestao in itemSugestoes.sugestoes.slice(1)">
                                    <td>{{sugestao.cfop}}</td>
                                    <td>{{(sugestao.csosns || sugestao.csts) | array}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </efd-alerta-nfe>
                </div>
            </div>
        `
    })
